<template src="./FichaPPAfiliacion.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Button, Descriptions, DescriptionsItem, Divider, Option, Select} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import {requestAfiliacionPPMixin} from "@/api/partidoPolitico/afiliacionPPApi";
import {FichaAfiliacionMixin} from "@/mixins/FichaAfiliacionMixin";
import Autocomplete from "@/components/Shared/Autocomplete/Autocomplete";
import {requestCoreMixin} from "@/api/coreApi";
import {rutClean, rutValidate} from "rut-helpers";

export default {
  name: "FichaPPAfiliacion",
  components: {
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Autocomplete.name]: Autocomplete,
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Divider.name]: Divider,
  },
  data: () => ({
    loading: true,
    errored: false,
    model: {
      person: '',
      suggestions: {},
      showCiudadano: false,

      seleccionado: '',
      afiliaciones: [],
      period: '',
      listperiods: [
        {
          glosa: "Última Afiliación",
          codigo: 1
        },
        {
          glosa: "Seleccionar una Afiliación",
          codigo: 2
        },
      ]
    },
  }),
  mixins: [
    requestCoreMixin,
    requestAfiliacionPPMixin,
    ScreenSizeMixin,
    NotifyMixin,
    FichaAfiliacionMixin
  ],
  computed: {
    isTypingPerson: function () {
      if (!isNaN(this.model.person) && this.model.person >= 8) {
        return true
      }
      return this.model.person.length > 5
    }
  },
  methods: {
    generateFicha() {
      this.$log.debug(this.model.ciudadano.rut)
      this.generate(this.model.ciudadano.rut)
    },
    selectPeriodPP() {
      this.$log.debug(this.model.ciudadano.rut)
      if (this.model.period === 2) {
        this.model.seleccionado = ''
        this.model.afiliaciones = []
        this.listaAfiliacionAceptada(this.model.ciudadano.rut)
      }
    },
    personChange() {
      this.model.showCiudadano = false
      this.model.ciudadano = {}
      this.model.period = ''
      this.model.seleccionado = ''
      this.model.afiliaciones = []
    },
    querySearchAsync(queryString, cb) {
      if (!this.isTypingPerson) {
        return cb([])
      }
      let person = this.model.person
      if (rutValidate(person)) {
        person = rutClean(this.model.person)
      }
      this.findAfiliacionByRutOrName(person)
        .then(response => {
          this.$log.debug('findAfiliacionByRutOrName', response.data.statusCode)

          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos)

            const results = data.map(x => {
              return {
                key: x.cedula,
                value: x.fullname
              }
            })
            return cb(results)
          } else if (response.data.statusCode === 404) {
            this.showWarn('No se encuentra un ciudadano con esos datos de búsqueda.')
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos')
          }
        })
        .catch(err => {
          this.$log.fatal('findAfiliacionByRutOrName', err, err.response, err.request)
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos')
        })

    },
    handleSelect(item) {
      this.model.ciudadano.rut = item.key
      this.model.ciudadano.nombreCompleto = item.value
      this.model.showCiudadano = true
    }
  }
}
</script>

<style>
.rutNombreClass label {
  float: none;
}
</style>
